import StatusesTable from './StatusesTable';

export default StatusesTable;
